const state = {
  isLoading: false,
  features: null,
  warnedOnce: false,
};

export default state;
